export default {
    phoneNumber: '+17026909711',
    faxNumber: '+18887761880',
    workZip: '89521',
    workState: 'NV',
    workCity: 'Reno',
    workAddress: '10627 Professional Cir., Ste A',
    organizationName: 'Cirrus Medical Network',
};



// WEBPACK FOOTER //
// ./src/sources/constants/defaultContactInformation.js